// put global variables here

import axios from 'axios';

// Send cookies so the httpOnly adm_access_token cookie rides along on every
// authenticated API call. The API is served same-origin via CloudFront path
// routing (see doc/plan/same-domain-api-impl.md), so this is same-origin in prod.
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 429) {
            alert('Server is busy — please wait a few seconds and try again.');
        }
        return Promise.reject(error);
    }
);

export const charsheetAPI = process.env.REACT_APP_CHARSHEET_API || '/api/charsheet-access'

export const TABLE_CHARS = 'charsheet-test'
export const TABLE_USERS = 'charsheet-users'
export const TABLE_SPELLS = 'Spells-Database-1E'

export const DEFAULT_CAMPAIGN = 'Greyhawk20'

export const CAMPAIGN_ASSETS_URL = 'https://adm-campaign-assets.s3.us-west-2.amazonaws.com'

export const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID || '1084196359898415255'
export const DISCORD_REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI || 'http://localhost:3000/oauth2/callback/'
export const DISCORD_API_URL = 'https://discordapp.com/api/users/@me'

export const DISCORD_CAMPAIGN_SERVER = '967890481105223700'
export const DISCORD_CAMPAIGN_CHANNEL = '1034975959834701935'
export const DISCORD_DEV_SERVER = '1063859029874589787'
export const DISCORD_DEV_CHANNEL = '1063859030772174864'

export const DIRTY_SAVEBUTTON_STYLE = { backgroundColor: '#d97706a6', color: '#111827', border: '2px solid #0612c0' }; // '#7c360a'
